import { FC, memo } from 'react';
import { mergeClasses, ProgressBar } from '@fluentui/react-components';
import RewardProgramCard from 'src/components/molecules/reward-program-card/RewardProgramCard';
import { ClassicActionProgramParticipantStatus } from 'src/models/rewards/Rewards';
import { availabilityStateCallToAction, isParticipantProgramEnded } from 'src/utils/utils';
import { AvailabilityState } from 'src/utils/enums';
import { useStyles } from './ClassicActionProgramCard.styles';

interface Props {
  participantStatus: ClassicActionProgramParticipantStatus
  customClassName?: string
}

const ClassicActionProgramCard: FC<Props> = ({
  participantStatus,
  customClassName,
}) => {
  const styles = useStyles();
  const { name, programTypeStatus } = participantStatus ?? {};
  const overallPercentCompleted = programTypeStatus?.overallPercentCompleted ?? 0;
  const state = programTypeStatus?.state ?? '';

  const isProgramTargetReached = overallPercentCompleted >= 100 && isParticipantProgramEnded(state);
  const percentCompleted = overallPercentCompleted > 100 ? 100 : overallPercentCompleted;
  const currentProgressText = `${percentCompleted}% Completed`;
  const ctaText = availabilityStateCallToAction(state);

  const renderProgressBar = (): JSX.Element => (
    <div className={mergeClasses('progress-bar-wrapper', styles.progressBarWrapper)}>
      <span className={styles.overallPercentCompleted}>
        {currentProgressText}
      </span>
      <ProgressBar
        value={percentCompleted}
        max={100}
        shape="square"
        thickness="large"
        className={mergeClasses('classic-action-progress-bar', styles.progressBar, customClassName)}
      />
    </div>
  );

  return (
    <RewardProgramCard
      programName={name}
      programParticipantStatus={participantStatus}
      cta={ctaText}
      isProgramTargetReached={isProgramTargetReached}
    >
      {state !== AvailabilityState.NotAvailableYet && renderProgressBar()}
    </RewardProgramCard>
  );
};

export default memo(ClassicActionProgramCard);
